import { type FilterValues } from "components/filters/FilterContext";
import { mapKeywordFilterToInstruction, mapResponseToKeywordFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (environment: server.dto.Environments) => (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedFreeFieldProfileInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    environment,
    page,
    perPage,
    excludeKeys: [],
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListFreeFieldProfileFilters
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response?.keyword),
});